const config = {
  baseURL: window.REACT_APP_API_URL ?? "http://localhost:8082",
  wsUrl: window.REACT_APP_WS_URL ?? "ws://localhost:8082",
  supportLanguages: ["en", "ar", "es", "fr"],
  maxFileSize: 2,
  blockedEntity: ["EH"],
  recaptchaSiteKey:
    window.CAPTCHA_SITE_KEY ?? "6LcUQ_EqAAAAAH07cTrFFsLx8SVct0AaZAYo2nmz",
  cndpNumber: "XXXXXX",
};

export default config;
